export const LABEL_ACCEPT = {
  es_ES: 'Aceptar',
  en_US: 'Accept',
  pt_BR: 'Aceitar',
  fr_FR: 'Accepter',
  de_DE: 'Akzeptieren',
  it_IT: 'Accettare',
};
